<div class="desktop-width-limiter overview-page overview-map-page" style="padding-top: 10px">
  <overview-filters
    (filterChanged)="setFilterAndFetch($event)"
    (changeLocationClicked)="openSettingsDialog()"
    (myLocationClicked)="resetMapToMyLocation()"
    (newLocationSelected)="resetMapToNewLocation($event)"
    [showLocationSelector]="true"
  [showSearch]="true"></overview-filters>
  <div class="overview-maps">
    <azure-map #mapelement></azure-map>
  </div>

  @if (loading) {
    <div class="loading">
      <mat-progress-spinner class="loading-spinner" [diameter]="250" mode="indeterminate" color="primary">
      </mat-progress-spinner>
      <div class="loading-text"><h1>Starten...</h1></div>
    </div>
  }

  @if (errorText) {
    <div class="errorText">
      {{'page.error' | translate}}
    </div>
  }
</div>
